var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import FileUpload from "~/components/common/file-upload.vue";
import { PageService } from "~/utils/page.service";
import { OutsourceReconciliationManageService } from "~/services/domain-service/outsource-reconciliation-manage.service";
import { Emit } from 'vue-property-decorator';
// @Auth(414)
var ImportPayRecord = /** @class */ (function (_super) {
    __extends(ImportPayRecord, _super);
    function ImportPayRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.importLoading = false;
        _this.fileList = [];
        return _this;
    }
    ImportPayRecord.prototype.refreshData = function () { };
    ImportPayRecord.prototype.close = function () {
        this.refresh();
    };
    /**
     * 确认核对
     */
    ImportPayRecord.prototype.submit = function () {
        var _this = this;
        if (this.fileList.length === 0) {
            this.$message('请先上传文件');
            return;
        }
        if (this.fileList.length > 1) {
            this.$message('请最多上传一个文件');
            return;
        }
        this.importLoading = true;
        var fileId = this.fileList[0].response.id;
        this.outsourceReconciliationManageService.importRepaymentRecord({ fileId: fileId }).subscribe(function (data) {
            _this.importLoading = false;
            _this.$message.success("导入成功");
            _this.refreshData();
            _this.close();
        });
    };
    ImportPayRecord.prototype.refresh = function () {
        var fileUpload = this.$refs['file-upload'];
        fileUpload.reset();
    };
    __decorate([
        Dependencies(PageService)
    ], ImportPayRecord.prototype, "pageService", void 0);
    __decorate([
        Dependencies(OutsourceReconciliationManageService)
    ], ImportPayRecord.prototype, "outsourceReconciliationManageService", void 0);
    __decorate([
        Emit('refreshData')
    ], ImportPayRecord.prototype, "refreshData", null);
    __decorate([
        Emit('close')
    ], ImportPayRecord.prototype, "close", null);
    ImportPayRecord = __decorate([
        Layout('workspace'),
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], ImportPayRecord);
    return ImportPayRecord;
}(Vue));
export default ImportPayRecord;
